module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAFVBMVEXQDDP////yu8b42uDtpLP99fb65upyaUfqAAAATUlEQVR4Xu3TMQ2AQBBFwZXAOiCrAAtYwMH5N0ECDTSbXALdvH66/+PVnldbdCEIgiAIgnTVs3GTo5rWyNmW3wmCzC/524shCIIgCIKcAWV/AH8wBXAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Denmark.png
// module id = 568
// module chunks = 0